export const color = {
  bg_white: "#FFFFFF",
  bg_soft_grey: "#F9F9F9",
  bg_grey: "#EFEFEF",
  bg_soft_blue: "#B9CFEB",
  bg_light_blue: "#789DCC",
  bg_blue: "#273E71",
  bg_dark_blue: "#192750",
  bg_soft_gold: "#FFF1D7",
  bg_gold: "#EFB03C",
  bg_pink: "#FFEDED",
  bg_soft_green:"#B7EFC2",
  bg_green: "#189630",
  text_grey:"#9B9B9B",
  text_charcoal: "#444444",
  text_black: "#000000",
  pop_blue:"#2B50CB",
  pop_orange:"#F55D25",
  pop_green: "#32CD32",
  pop_yellow:"#F8E71C",
  pop_red:"#EA0420",
  overlay_black: "rgba(0, 0, 0, 0.6)"
}